// Stub for @mui/material — MUI removed while gantt-task-react still depends on it.
// Remove this stub when @thepocman/gantt-task-react is replaced.
const passthrough = ({ children = null }) => children;
export const IconButton = passthrough;
export const ThemeProvider = passthrough;
export const Tooltip = passthrough;
export const ClickAwayListener = passthrough;
export const Paper = passthrough;
export const Popper = passthrough;
export const createTheme = () => ({});
export default passthrough;
